import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SpacesMobile from './SpacesMobile';
import SpacesDesktop from './SpacesDesktop';
import './List.css';

const List = ({ property, isDesktop, filters }) => {
    const spacesInfo = property.spaces.map(({ space }, i) => ({
        id: (i + 1),
        address: property.street_address,
        floor: space.floor,
        suite: space.suite,
        space_available: space.space_available,
        maximum_contiguous: space.maximum_contiguous,
        minimum_divisible: space.minimum_divisible,
        floor_plans: space.floor_plans,
        street_address: space.street_address,
    }));

    return (
        <div className="property-wrapper">
            {isDesktop
                ? <SpacesDesktop
                    property={property}
                    spacesInfo={spacesInfo}
                    filters={filters}
                />
                : <SpacesMobile
                    property={property}
                    spacesInfo={spacesInfo}
                    filters={filters}
                />
            }
        </div>
    );
};

List.propTypes = {
    property: PropTypes.shape({
        street_address: PropTypes.string.isRequired,
        spaces: PropTypes.arrayOf(PropTypes.shape({
            space: PropTypes.shape({
                floor: PropTypes.string, //.isRequired,
                suite: PropTypes.string, //.isRequired,
                maximum_contiguous: PropTypes.string, //.isRequired,
                minimum_divisible: PropTypes.string, //.isRequired,
                floor_plans: PropTypes.arrayOf(PropTypes.string),
            }), //.isRequired,
        })).isRequired,
    }).isRequired,
    isDesktop: PropTypes.bool,
    filters: PropTypes.object,
};

export default connect(
    ({ screen }) => ({ isDesktop: screen.isDesktop }),
    null
)(List);
